import React from 'react';
import Paper from '@material-ui/core/Paper';

const CustomTooltip = ({ payload }: { payload?: any }) => {
  if (payload.length === 0) return null;

  return (
    <Paper style={{ padding: '1rem' }}>
      <strong>{payload[0].payload.name}</strong>
      {payload.map((item: any) => {
        return (
          <p key={item.name}>
            {item.name} {item.value}
          </p>
        );
      })}
    </Paper>
  );
};

export default CustomTooltip;
